<template>
  <div v-if="showNewsletterSticky" class="newsletter-sticky" ref="newsletterSticky" :class="[ newsletterScroll ? 'show-newsletter-sticky':'hide-newsletter-sticky',position]">
    <div class="newsletter-sticky__container">
      <p @click="showNewsLetterPopin()" :style="{color: textColor}" v-html="newsletterStickyText"></p>
      <button class="newsletter-sticky__btn" @click="showNewsLetterPopin()">
        <svg class="newsletter-sticky__arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M20.425 8.42409L12.0009 16.8484L3.57644 8.4241L4.42496 7.57556L12.0009 15.1513L19.5764 7.57557L20.425 8.42409Z" fill="black"/>
        </svg>
      </button>
      <button id="btn_close" class="btn_close close" aria-label="Close" @click="closeStickyBar(true)">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.1515 12L3.57574 19.5757L4.42427 20.4243L12 12.8485L19.5757 20.4243L20.4243 19.5757L12.8485 12L20.4243 4.42427L19.5757 3.57574L12 11.1515L4.42427 3.57574L3.57574 4.42427L11.1515 12Z" fill="black"/>
        </svg>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'newsletter-sticky',
  props: {
    newsletterStickyText: {
      type: String,
      default: '',
    },
    position: {
      type: String,
      default: '',
    },
    textColor: {
      type: String,
      default: '#000000',
    },
    pageCategory: {
      type: String,
      default:''
    }
  },
  data() {
    return {
      showNewsletterSticky: false,
      newsletterScroll: true,
    };
  },
  created() {
    this.initialRendering();
  },
  mounted() {
    window.addEventListener('scroll',() => {
      var el = this.$refs.newsletterSticky;
      if(el != null) {
        const currentScroll = window.pageYOffset;
        if(currentScroll === 0) {
          this.newsletterScroll = true;
          this.showStickyOnTop(true);
        }else{
          this.newsletterScroll = false;
          this.showStickyOnTop(false);
        }
      }
    });
  },
methods: {
    closeStickyBar(isClose = false) {
      this.showNewsletterSticky = false;
      document.cookie = 'newsletterSticky=true';
      this.showStickyOnTop(false);
      if(isClose) {
          let action = 'close';
          let desktopScreen = window.matchMedia('(min-width: 767px)').matches;
          let pos = desktopScreen ? 'top' : this.position;
          window.dataLayer.push({
            'event': 'uaevent',
            'ecommerce': 'undefined',
            'event_name':'sticky_bar',
            'eventCategory': this.pageCategory,
            'eventAction': 'newsletter_sticky',
            'eventLabel': action +' '+ pos.toLowerCase(),
            'module_name':'newsletter_sticky',
            'cta_name': action +' '+ pos.toLowerCase()
        });
      }
    },
    initialRendering() {
      const getStickyCookie = document.cookie
        .split(';')
        .filter((cookieItem) => cookieItem.includes('newsletterSticky'));
      window.eventBus.$on('newsletterSticky', () => {
        this.showNewsletterSticky = !getStickyCookie.length;
        if (this.showNewsletterSticky) {
          this.showStickyOnTop(true);
        }
      });
      window.eventBus.$on('newsletterStickyClose', () => {
        this.closeStickyBar();
      });
    },
    showStickyOnTop(val) {
      let desktopScreen = window.matchMedia('(min-width: 767px)').matches;
      if (this.position !== 'Bottom' || desktopScreen) {
        this.$nextTick(() => {
          window.eventBus.$emit('newsletter-sticky-open-menu', val);
        });
      }
    },
    showNewsLetterPopin() {
      this.showNewsletterSticky = false;
      let desktopScreen = window.matchMedia('(min-width: 767px)').matches;
      let pos = 'sticky bar';
      window.eventBus.$emit('newsletterpopup', {postion: pos, show: true});
      let body = document.getElementsByTagName("body");
      if(body) {
        body[0].classList.add("newsletterPopup");
      }
      let action = 'click';
      window.dataLayer.push({
          'event': 'uaevent',
          'ecommerce': 'undefined',
          'event_name':'sticky_bar',
          'eventCategory': this.pageCategory,
          'eventAction': 'newsletter_sticky',
          'eventLabel': action +' '+ pos.toLowerCase(),
          'module_name':'newsletter_sticky',
          'cta_name': action +' '+ pos.toLowerCase()
      });
    },    
  },
  destroyed(){
    window.removeEventListener('scroll');
  }
};
</script>

